import React from 'react'
import PropTypes from 'prop-types'

import { CenterPopup, PreorderForm } from '../../index'

function PreorderPopup({ productData, closeAction }) {
  return (
    <CenterPopup closeAction={closeAction} className="preorder-popup">
      <PreorderForm productData={productData} successAction={closeAction} />
    </CenterPopup>
  )
}

PreorderPopup.propTypes = {
  productData: PropTypes.object.isRequired,
  closeAction: PropTypes.func.isRequired,
}

export default PreorderPopup
